import React from 'react';

/** A recruitment status name with its colour swatch, or "Not set" when there is none. */
export default function RecruitmentStatusLabel({ status }) {
    if (!status) {
        return (
            <span className="tw-inline-flex tw-items-center tw-gap-x-2 tw-text-charcoal-75">
                <span className="tw-inline-block tw-w-2.5 tw-h-2.5 tw-rounded-full tw-border tw-border-charcoal-25" />
                {$t('Not set')}
            </span>
        );
    }

    return (
        <span className="tw-inline-flex tw-items-center tw-gap-x-2">
            <span className="tw-inline-block tw-w-2.5 tw-h-2.5 tw-rounded-full tw-shrink-0" style={{ backgroundColor: status.colour }} />
            {status.name}
        </span>
    );
}
